import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';

/**
 * The conversation lives on Home (`/home`) now. This route only keeps old
 * links, bookmarks and `/chat/history`'s siblings working by landing them there
 * with the composer focused. It declares no `staticData.app`, so it never shows
 * up as a navigable page or in the sidebar.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/chat',
  beforeLoad: () => {
    throw redirect({ to: '/home' });
  },
});
